import { login, loginFB, loginGoogle } from '../auth/authActions';
import { useNavigate } from 'react-router-dom';
import FacebookLogin from '@greatsumini/react-facebook-login';
import { GoogleLogin } from '@react-oauth/google';
import { loginSuccess } from '../auth/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import './Login.css';
import { useTranslation } from 'react-i18next';
import React, { useState, useEffect } from 'react';

const Login = () => {
  const { t } = useTranslation();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showErrorOverlay, setShowErrorOverlay] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  useEffect(() => {
    if (isLoggedIn) {
      navigate("/mygames");
    }
  }, [isLoggedIn, navigate]);

  const handleLogin = async () => {
    const result = await dispatch(login(username.trim(), password.trim()));

    if (!result) {
      setShowErrorOverlay(true);
    } else {
      dispatch(loginSuccess());
      localStorage.setItem('token', result.token);
      navigate("/mygames");
    }
  };

  const onGoogleSuccess = async (response) => {
    console.log("google login success: ", response);

    const result = await dispatch(loginGoogle(response.credential));
    if (!result) {
      setShowErrorOverlay(true);
    } else {
      dispatch(loginSuccess());
      localStorage.setItem('token', result.token);
      navigate("/mygames");
    }
  };

  const onGoogleFailure = (response) => {
    console.log("google login failure: ", response);
    setShowErrorOverlay(true);
  };

  const handleRegisterClick = () => {
    navigate('/register');
  };

  return (
    <div className="login-container">
      <h2>{t("login")}</h2>
      <form className="login-form">
        <label>
          {t("username")}:
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
        </label>
        <label>
          {t("password")}:
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <div className="login-buttons">
          <button type="button" onClick={handleLogin}>
            {t("login")}
          </button>
          <button type="button" onClick={handleRegisterClick}>
            {t("register")}
          </button>
        </div>
      </form>

      {/* Facebook and Google buttons */}
      <div className="platform-buttons">
        {/* Facebook Login */}
        <FacebookLogin
          appId="1075421440241911"
          onSuccess={async (response) => {
            console.log("fb login success:", response);
            const result = await dispatch(loginFB(response.accessToken, response.userID));

            if (!result) {
              setShowErrorOverlay(true);
            } else {
              dispatch(loginSuccess());
              localStorage.setItem('token', result.token);
              navigate("/mygames");
            }
          }}
          onFail={(error) => {
            console.log("fb login error:", error);
            setShowErrorOverlay(true);
          }}
          style={{
            backgroundColor: "#4267b2",
            color: "#fff",
            padding: "8px 16px",
            border: "none",
            borderRadius: "4px",
            fontSize: "14px",
            cursor: "pointer",
            margin: "5px",
          }}
        />

        {/* Google Login */}
        <div className="google-login-container">
          <GoogleLogin
            onSuccess={onGoogleSuccess}
            onError={onGoogleFailure}
            theme="outline"
            size="large"
            width="250"
            style={{ margin: "5px auto", display: "block" }}
          />
        </div>
      </div>

      {/* Overlay error */}
      {showErrorOverlay && (
        <div className="overlay">
          <div className="overlay-content">
            <h2>{t("login_error")}</h2>
            <p>{t("invalid_username_or_password")}</p>
            <button onClick={() => setShowErrorOverlay(false)}>{t("close")}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
